import { ILogger } from "../Components/ILogger";
import { LoginResult } from "../Models/LoginResult";
import { AdminLoginResult } from "./AdminLoginResult";
import { ConfigProvider } from "./ConfigProvider";


export class AuthService
{
    public ValidPassword: string =  window.localStorage.getItem("valid-password") || "";
    public PhotosServerAuthToken: string = window.localStorage.getItem("photos-server-auth-token") || "";
    public AdminWatcherToken: string = window.localStorage.getItem("admin-watcher-token") || "";
 
    constructor(private _config: ConfigProvider, private _logger: ILogger) 
    { }

    public get UserId(): string
    {
        let userId = window.localStorage.getItem("user-id");

        if (!userId)
        {
            userId = "A-" + Math.random().toString(16).substring(2, 7).toUpperCase();
            window.localStorage.setItem("user-id", userId);
        }

        return userId;
    }

    public async TryLogin(password: string): Promise<LoginResult>
    {
        try 
        {
            this._logger.Log(`Trying login to ${this._config.CurrentServerAddr.value} using password "${password}"...`);

            const fetchResponse = await fetch(`${this._config.CurrentServerAddr.value}/admin/login`, {
                method: 'POST',      
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    Password: password,
                }),
            });
            const result = await fetchResponse.json() as AdminLoginResult;
            const response = { status: fetchResponse.status };

            if (response.status == 200 && result.Message === "OK")
            {
                this.ValidPassword = password;
                window.localStorage.setItem("valid-password", this.ValidPassword);

                window.localStorage.setItem("photos-server-auth-token", result.Claims.DemoPhotosServerAuthToken || "")
                this.PhotosServerAuthToken = result.Claims.DemoPhotosServerAuthToken || "";

                window.localStorage.setItem("admin-watcher-token", result.Claims.AdminWatcherToken || "")
                this.AdminWatcherToken = result.Claims.AdminWatcherToken || "";

                this._logger.Log(`Authorized successfully.`);

                return new LoginResult(true);
            }
            else 
            {
                this._logger.Log(`Non-200 login result: ${JSON.stringify(result)}`);
                return new LoginResult(false, result.Message || "Unknown problem");
            }
        }
        catch (ex)
        {
            this._logger.Log(`Faulty login result: ${ex.message}`);
            return new LoginResult(false, "Network problem");
        }
    }

    public Logout(): void
    {
        this.ValidPassword = "";
        this.PhotosServerAuthToken = "";
        window.localStorage.setItem("valid-password", "")
        window.localStorage.setItem("admin-password-input", "")
        window.localStorage.setItem("photos-server-auth-token", "")
    }

    public get IsLoggedIn(): boolean
    {
        return this.ValidPassword.length > 0;
    }
}
